import { render, staticRenderFns } from "./login-via-code.vue?vue&type=template&id=cb49085e"
import script from "./login-via-code.vue?vue&type=script&lang=js"
export * from "./login-via-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports